<mat-card [ngClass]="bgBlue ? 'bg-blue' : ''">
  <mat-card-title>
    <div class="template-title" *ngIf="title">
      <div class="back-button">
        <img class="arrow-icon" src="../../../../../assets/svg/arrow_back.svg" alt="">
      </div>

      <img [src]="logo ? logo : '../../../../../assets/logotipe/CLINNG.svg'" class="logotipe"
        alt="Clinng">
    </div>
  </mat-card-title>
  <mat-card-content>
    <div class="title-text" style="width: 183px;">
      <h2 style="font-size: 36px; margin-top: 0;">{{ title }}</h2>
    </div>
    <ng-content select="[slot=content]"></ng-content>
  </mat-card-content>
  <mat-card-actions *ngIf="showFooter">
    <img src="../../../../../assets/logotipe/CLINNG.svg" class="logotipe" alt="Clinng">
  </mat-card-actions>
</mat-card>